// FILE: src/firebase/config.js

import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
// The adminSecret is also imported from the dynamically generated file
import { firebaseConfig, adminSecret as importedAdminSecret } from './firebase.env.js';

let app;
let auth;
let db;
let adminSecret = importedAdminSecret; // Assign the imported secret to a local export

// Only initialize Firebase if the API key is provided.
if (firebaseConfig && firebaseConfig.apiKey) {
  try {
    app = initializeApp(firebaseConfig);
    auth = getAuth(app);
    db = getFirestore(app);
  } catch (error) {
    console.error("Firebase initialization failed:", error);
  }
} else {
  console.error("Firebase configuration is missing. Ensure firebase.env.js exists and is configured correctly.");
}

export { app, auth, db, adminSecret };
